import React from 'react';

const LOGO_SOURCES = [
  '/images/logo-80.webp',
  '/images/logo-80-light.webp',
  '/logo192.png',
];

export default function LogoIcon() {
  const [logoIdx, setLogoIdx] = React.useState(0);
  const logoSrc = LOGO_SOURCES[logoIdx];

  const handleLogoError = () => {
    setLogoIdx((i) => Math.min(i + 1, LOGO_SOURCES.length - 1));
  };

  return (
    <img
      src={logoSrc}
      srcSet={`${logoSrc} 1x, ${logoSrc.replace('-80', '-160')} 2x, ${logoSrc.replace('-80', '-240')} 3x`}
      alt="Ground Rounds"
      width={80}
      height={80}
      loading="eager"
      onError={handleLogoError}
      className="block w-full h-full object-cover bg-transparent"
    />
  );
}
